var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5858 6.84451C21.814 6.57253 22.2195 6.53706 22.4915 6.76527L24.5707 8.50998C24.8427 8.7382 24.8782 9.14368 24.65 9.41566L18.1119 17.2074C18.0301 17.3049 17.9213 17.3759 17.7991 17.4115L15.455 18.0936C15.0154 18.2216 14.5867 17.8619 14.6363 17.4067L14.9011 14.9798C14.9149 14.8533 14.9659 14.7337 15.0477 14.6363L21.5858 6.84451Z",
    stroke: "#7D86A1",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3865 7.35205C15.3562 7.35205 12.3107 7.35205 8.25 7.35205C7.00736 7.35205 6 8.35941 6 9.60205V23.1021C6 24.3447 7.00736 25.3521 8.25 25.3521H21.75C22.9926 25.3521 24 24.3447 24 23.1021C24 19.5165 24 16.8273 24 15.0345",
    stroke: "#7D86A1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editIcon.2be04911.svg";
export { ForwardRef as ReactComponent };